export default __webpack_public_path__ + "static/media/product_3_friim_1.9e10ce4f.png";